module.exports = __webpack_public_path__ + "static/media/9.1.ad1e4548.png";